<template>
  <div class="d-flex justify-space-between align-center pb-4 current-section">
    <div v-if="selectedSection.type !== 'style-config'" class="mt-0">
      <TextField
        :placeholder="types[selectedSection.type]"
        v-model="selectedSection.name"
        backgroundColor="white"
        width="270px"
        :showBorder="false"
        customStyle="margin-left: -20px; font-size: 20px !important; font-weight: 700 !important; color: #0079CB !important"
      />    
    </div>
    <b v-else class="titleToolbar">{{ selectedSection.name || types[selectedSection.type] }}</b>

    <div class="d-flex" style="gap: 12px">
      <v-btn fab color="transparent" elevation="0" x-small class="mr-n3">
        <v-icon color="primary" size="18" @click="handleCloseSection">fas fa-close</v-icon>
      </v-btn>

      <v-btn v-if="selectedSection.type !== 'style-config'" fab color="transparent" elevation="0" x-small>
        <v-icon color="primary" size="15" @click="removeSection(selectedSection)">fa-regular fa-trash</v-icon>
      </v-btn>
    </div>

    <ConfirmDialog 
      :key="selectedSection.name"
      v-model="isDeleteDialogOpen"
      title="Remoção de seção"
      :showTitleDivider="false"
      @confirmDone="confirmRemoveSection(sectionToDeleteId)"
    >
    <template v-if="sectionToDeleteId" slot="content">
      <div class="pt-2 pb-5">
        Deseja remover a seção <b>{{ selectedSection.name || types[selectedSection.type] }}</b>? <br>Essa ação não poderá ser desfeita.
      </div>
    </template>
    </ConfirmDialog>    
  </div>  
</template>

<script>
import { mapGetters } from 'vuex'
import TextField from '../../_v2/ui/TextField.vue'
import ConfirmDialog from '../../_v2/ui/ConfirmDialog.vue'

export default {
  name: "CurrentSection",
  components: { TextField, ConfirmDialog },
  props: {
    selectedSection: {type: Object, required: true},
    types: {type: Object, required: true},
    handleCloseSection: {type: Function, required: true}
  },
  computed: {
    ...mapGetters(['infos'])
  },

  data: () => ({
    sectionToDeleteId: null,
    isDeleteDialogOpen: false    
  }),

  methods: {
    removeSection(section) {
      this.sectionToDeleteId = section.id
      this.isDeleteDialogOpen = true
    },

    confirmRemoveSection(sectionToDeleteId) {
      this.handleCloseSection()
      this.infos.sections = this.infos.sections.filter(section => section.id !== sectionToDeleteId)
      this.sectionToDeleteId = null
    },
  }
}
</script>

<style scoped>
.titleToolbar {
  font-family: Inter !important;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 150%;
  color: #0079CB;
}

.current-section /deep/ .v-input input, .current-section /deep/ .v-input input::placeholder {
  color: #0079CB !important;
}
</style>